import React, { useState } from "react";
import Icon from "components/AppIcon";

import Input from "components/ui/Input";

const SecurityConfig = ({ config, onChange, onTest }) => {
  const [showSmtpPassword, setShowSmtpPassword] = useState(false);

  const handleChange = (field, value) => {
    onChange("security", field, value);
  };

  return (
    <div className="space-y-6">
      {/* Password Policy */}
      <div className="rounded-xl border p-4 md:p-6" style={{ backgroundColor: "var(--color-card)", borderColor: "var(--color-border)" }}>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ backgroundColor: "rgba(15,118,110,0.1)" }}>
            <Icon name="Lock" size={18} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="font-heading font-700 text-base" style={{ color: "var(--color-foreground)" }}>Política de Contraseñas</h3>
            <p className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>Requisitos mínimos de seguridad para contraseñas</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Longitud mínima"
            type="number"
            value={config?.minPasswordLength}
            onChange={(e) => handleChange("minPasswordLength", e?.target?.value)}
            placeholder="8"
            description="Número mínimo de caracteres"
          />
          <Input
            label="Intentos máximos de inicio de sesión"
            type="number"
            value={config?.maxLoginAttempts}
            onChange={(e) => handleChange("maxLoginAttempts", e?.target?.value)}
            placeholder="5"
            description="Bloqueo tras N intentos fallidos"
          />
          <Input
            label="Expiración de contraseña (días)"
            type="number"
            value={config?.passwordExpiryDays}
            onChange={(e) => handleChange("passwordExpiryDays", e?.target?.value)}
            placeholder="90"
            description="0 = sin expiración"
          />
          <Input
            label="Historial de contraseñas"
            type="number"
            value={config?.passwordHistory}
            onChange={(e) => handleChange("passwordHistory", e?.target?.value)}
            placeholder="5"
            description="No reutilizar las últimas N contraseñas"
          />
        </div>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
          {[
            { key: "requireUppercase", label: "Requerir mayúsculas" },
            { key: "requireNumbers", label: "Requerir números" },
            { key: "requireSpecialChars", label: "Requerir caracteres especiales" },
            { key: "requireMFA", label: "Autenticación multifactor (MFA)" },
          ]?.map(({ key, label }) => (
            <label key={key} className="flex items-center gap-3 cursor-pointer p-3 rounded-lg transition-base hover:bg-opacity-50" style={{ backgroundColor: "var(--color-muted)" }}>
              <div
                className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0 transition-base"
                style={{
                  backgroundColor: config?.[key] ? "var(--color-primary)" : "transparent",
                  border: `2px solid ${config?.[key] ? "var(--color-primary)" : "var(--color-border)"}`,
                }}
                onClick={() => handleChange(key, !config?.[key])}
              >
                {config?.[key] && <Icon name="Check" size={12} color="white" strokeWidth={3} />}
              </div>
              <span className="text-sm font-caption" style={{ color: "var(--color-foreground)" }}>{label}</span>
            </label>
          ))}
        </div>
      </div>
      {/* Session Management */}
      <div className="rounded-xl border p-4 md:p-6" style={{ backgroundColor: "var(--color-card)", borderColor: "var(--color-border)" }}>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ backgroundColor: "rgba(8,145,178,0.1)" }}>
            <Icon name="Clock" size={18} color="var(--color-secondary)" />
          </div>
          <div>
            <h3 className="font-heading font-700 text-base" style={{ color: "var(--color-foreground)" }}>Gestión de Sesiones</h3>
            <p className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>Configuración de tiempos de sesión y URLs firmadas</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Tiempo de inactividad (minutos)"
            type="number"
            value={config?.sessionTimeout}
            onChange={(e) => handleChange("sessionTimeout", e?.target?.value)}
            placeholder="30"
            description="Cierre automático por inactividad"
          />
          <Input
            label="Duración máxima de sesión (horas)"
            type="number"
            value={config?.maxSessionDuration}
            onChange={(e) => handleChange("maxSessionDuration", e?.target?.value)}
            placeholder="8"
            description="Tiempo máximo de sesión activa"
          />
          <Input
            label="Expiración de URL firmada (horas)"
            type="number"
            value={config?.signedUrlExpiry}
            onChange={(e) => handleChange("signedUrlExpiry", e?.target?.value)}
            placeholder="24"
            description="Tiempo de validez para descargas"
          />
          <Input
            label="Sesiones simultáneas máximas"
            type="number"
            value={config?.maxConcurrentSessions}
            onChange={(e) => handleChange("maxConcurrentSessions", e?.target?.value)}
            placeholder="3"
            description="Por usuario"
          />
        </div>
      </div>
    </div>
  );
};

export default SecurityConfig;